/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntryType } from './entryType';
import { Updated } from './updated';


export interface FeedType { 
    id?: string;
    title?: string;
    updated?: Updated;
    numItems: number;
    entry?: Array<EntryType>;
}

